<p style="margin-top: 1rem; text-align: center;">
    Once you've created the cost approval request, it will be sent to the approver for review.
</p>

<nz-select nzPlaceHolder="Select Task" nzAllowClear nzShowSearch nzServerSearch [(ngModel)]="selectedTask"
    (nzOnSearch)="onSearch($event)">
    @if (!loading) {
    @for (o of optionList; track o.id) {
    <nz-option [nzValue]="o.id" [nzLabel]="o.name"></nz-option>
    }
    } @else {
    <nz-option nzDisabled nzCustomContent>
        <nz-icon nzType="loading" class="loading-icon" />
        Loading Data...
    </nz-option>
    }
</nz-select>


<nz-select nzPlaceHolder="Select Approver" nzAllowClear nzShowSearch [(ngModel)]="selectedUser" 
style="margin-top: 20px;">
    @for (o of userListData.value.results; track o.id) {
    <nz-option [nzValue]="o.id" [nzLabel]="o.name"></nz-option>
    }
</nz-select>


<textarea nz-input placeholder="Comment (minimum 10 characters)" style="margin-top: 20px;"
[(ngModel)]="comment" 
[nzAutosize]="{ minRows: 3, maxRows: 5 }"></textarea>

<button nz-button nzType="primary" (click)="create()" 
[disabled]="!selectedTask || !selectedUser || !(comment.length > 10)" style="width: 100%; margin-top: 20px;">
    Create
</button>